<template>
     <v-container grid-list-xs>
         <!-- align-center justify-center  -->
            <v-layout row class="amount_container">
                <v-flex xs12 sm12 md12 lg12 xl0 text-xs-center>

                    <v-dialog
                    v-model="dialog_info"
                    max-width="470"
                    :fullscreen="$vuetify.breakpoint.sm || $vuetify.breakpoint.xs"
                    >
                        <v-card>
                            <div class="with_back_btn_con">
                                <div class="go_back_container">
                                    <a @click="dialog_info = false"><span class="icon-next mr-3" ><IconBase width="24" height="24"><IconArrowBack /></IconBase></span></a><span class="ap_text">FDCA Membership</span>
                                </div>
                            </div>    
                            <v-card-text>
                                <div class="nav_close_container">
                                    <v-btn icon @click="dialog_info = false">
                                        <v-icon>close</v-icon>
                                    </v-btn>
                                </div>
                                <div class="modal_container">
                                    <div class="modal_body__content">As a member of Family Day Care Australia (FDCA) our focus is on representing, supporting and promoting you so that you can provide great outcomes for the children and families you support.
                                    </div>
                                    <div class="modal_body__content">When you become a member of FDCA you gain access to a wide range of member benefits, join a network of early childhood educators and service professionals across Australia and are making a vital contribution to our work in supporting, promoting and representing the sector.
                                    </div>
                                    <div class="modal_body__content">As your national, not-for-profit, peak body, your investment in us, is an investment in a stronger future for family day care.
                                    </div>
                                </div>
                            </v-card-text>
                        </v-card>
                    </v-dialog> 

                    


                    <div class="fdca_container">
                        <v-container grid-list-xl>
                            <v-layout id="premium-container" row wrap align-center justify-center>
                                <v-flex xs12 sm12 md12 lg12 xl8>
                                    <v-card flat class="premium-box">
                                        <v-card-text class=" -3 text-xs-center">
                                            <h3>Includes FDCA Membership</h3>
                                            <p class="mb-2">Join a network of early childhood educators and service professionals accross Australia</p>
                                            <p class="mb-0">
                                                <a @click="dialog_info = true"><span class="icolor"><IconBase><IconInformation /></IconBase></span><span class="span_text">More Benefits</span></a>

                                            </p>
                                        </v-card-text>
                                    </v-card>
                                </v-flex>
                                <v-flex xs12 sm12 md12 lg12 xl8>
                                    <v-card flat class="premium-box">
                                        <v-card-text class="pa-3 text-xs-center">
                                            <h3>Family Day Care Insurance</h3>
                                            <p class="mb-1">12 months cover</p>
                                            <p class="mb-1">Starting on 19/07/2020</p>
                                        </v-card-text>
                                        <v-card-text class="pa-3 text-xs-center">
                                            <h3>PUBLIC LIABILITY
                                                <v-tooltip v-model="show" top max-width="300" z-index="300" dark close-delay="100" bottom>
                                                    <template v-slot:activator="{ on }">
                                                        <a @click="clicktooltip('show')" class="atooltip" alt="Public Liability Insurance"><span class="icolor"><IconBase><IconInformation /></IconBase></span></a>
                                                        <!-- <v-btn icon v-on="on">
                                                        <v-icon color="grey lighten-1">shopping_cart</v-icon>
                                                        </v-btn> -->
                                                    </template>
                                                    <span class="tooltip__content">
                                                        Public Liability Insurance is mandatory for all educators.<br/>
                                                        If a child or other person is injured or their property is damaged<br/>
                                                        as a result of your work, you may be found "unintentionally negligent" and a pulic liability claim may be brought against you.<br/>
                                                        Should this occur, our Public Liability Insurance has you covered.
                                                    </span>
                                                </v-tooltip>
                                            </h3>
                                            <p class="mb-1">$20 Million Public Liability</p>
                                            <p class="mb-1">$20 Million Products Liability</p>
                                            <p class="mb-1">$10 Million Errors and Omissions</p>
                                            <p class="mb-1">$50,000 Fines and Penalties cover</p>
                                            <p class="mb-1">$0 Excess</p>
                                        </v-card-text>
                                        <v-card-text class="pa-3 text-xs-center">
                                            <h3>PERSONAL ACCIDENT
                                                <v-tooltip v-model="show1" top max-width="300" z-index="300" dark close-delay="100" bottom>
                                                    <template v-slot:activator="{ on }">
                                                        <a @click="clicktooltip('show1')" class="atooltip" alt="Public Liability Insurance"><span class="icolor"><IconBase><IconInformation /></IconBase></span></a>
                                                        <!-- <v-btn icon v-on="on">
                                                        <v-icon color="grey lighten-1">shopping_cart</v-icon>
                                                        </v-btn> -->
                                                    </template>
                                                    <span class="tooltip__content">
                                                        Accident happen and it's often not your fault.<br/>
                                                        Personal Accident for Children insurance covers out of pocket expenses incurred by parents when a child i accidentally injured whilst in your care.
                                                    </span>
                                                </v-tooltip>
                                            </h3>
                                            <p class="mb-1">$30,000 Accidental Death Benefit for Educator and Children</p>
                                            <p class="mb-1">#30,000 Capital Benefit for Educator and Children</p>
                                            <p class="mb-1">$5,000 Out-of-pocket expenses</p>
                                            <p class="mb-1">$0 Excess</p>
                                        </v-card-text>
                                    </v-card>
                                </v-flex>
                                <PremiumPoliceChecked></PremiumPoliceChecked>
                                <!-- <v-flex xs12 sm12 md12 lg12 xl8>
                                    <v-card flat class="premium-box text-xs-center">
                                        <v-card-text class="pa-3">
                                            <h3>Complete your Police Checked?</h3>
                                            <img src="../../assets/police_check_logo.png" height="50">
                                            <p class="mb-1">Claim $15 off your policy with your FDCA Polic Checks promo code</p>
                                            <v-layout id="premium-container" row wrap align-center justify-center>
                                                <v-flex xs10 sm6 md6 lg6 xl6>
                                                     <v-text-field
                                                    v-model="fdca_code"
                                                    label="Enter code"
                                                    single-line
                                                    outline
                                                    class=""
                                                    id="fdca_code"
                                                ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            <p class="mb-0"><a href="https://fdcapolichecks.com.au" target="_blank">fdcapolichecks.com.au</a></p>
                                        </v-card-text>
                                    </v-card>
                                </v-flex> -->
                            </v-layout>
                            <v-layout align-center justify-center row>
                            </v-layout>
                            <div class="total_container">
                                <v-layout align-center justify-center row>
                                </v-layout>
                            </div>

                            
                            
                        </v-container>
                    </div>

                    
                    
                </v-flex>
            </v-layout>
        </v-container>
</template>

<script>
// class="educator-route-nav educator-package-nav no_progress_bar"
import IconBase from '@/components/IconBase.vue'
import IconArrowRight from '@/components/icons/arrowForward.vue'
import IconArrowBack from '@/components/icons/arrowBack.vue'
import IconStarCheck from '@/components/icons/starCheck.vue'
import Globals from '@/assets/scripts/global-functions.js'
import IconInformation from '@/components/icons/information.vue'
import PremiumPoliceChecked from '@/components/forms/PremiumPoliceChecked.vue'

export default {
    name: "PremiumData",
    components: {
        IconBase,
        IconArrowRight,
        IconArrowBack,
        IconStarCheck,
        Globals,
        IconInformation,
        PremiumPoliceChecked
    },
    props: {
    },
    data () {
        return {
            show: false,
            show1:false
        }
    },
    mounted() {
        
        
    },
    methods: {
        clicktooltip(params){
            this[params] = true;
            setTimeout(() => {
                this[params] = false;
            }, 8000);
            
        }
        
    }
}
</script>

<style lang="scss" scoped>
    .insurance-process-step h3 {
        margin-bottom: 0.6rem;
        color: #0A2435;
        font-weight: 600
    }
    .upper-container {
        background: #0072BC !important;
        width: 100%;
    }

    .upper-container div, .table-container div a {
        color: #fff
    }

    .main_inner_container {
        max-width: 1024px;
        margin-left: auto;
        margin-right: auto;
    }

    #premium_data {
        font-size: 50px;
        font-weight: 600;
        text-align: center;
        margin-bottom: 5px;
    }

    
    .table-container {
        width: fit-content;
        display: block;
        margin-left: auto;
        margin-right: auto;
        margin-top: 15px;
    }

    .choice {
        width: 120px;
        height: 8px;
        background: #2080BF;
        display: inline-block
    }

    #choice1 {
        border-bottom-left-radius: 25px;
        border-top-left-radius: 25px
    }

    #choice3 {
        border-bottom-right-radius: 25px;
        border-top-right-radius: 25px
    }

    .dtable {
        display: table;
    }

    .drow {
        display: table-row;
    }

    .dcell {
        display: table-cell;
    }

    .default {
        background: #fff;
        border-radius: 25px;
        transition-timing-function: ease-out;
    }

    @media screen and (min-width: 0px) and (max-width: 470px) {
        #choice1,
        #choice2 {
            width: calc(80px + 2 * ((100vw - 320px) / 680));
        }
        #choice3 {
            width: calc(120px + 2 * ((100vw - 320px) / 680));
        }
        #toggle_fortnight {
            margin: 0px 10px;
        }
        .back-container {
            text-align: left;
            margin-bottom: 0;
        }
    }

    .back-container {
        padding-top: 40px;
    }

    .back-container a {
        color: #fff;
        float: left;
    }

    @media screen and (max-width: 1263px) and (min-width: 0px) {
        .main_inner_container {
            margin-left: 5%;
            margin-right: 5%;
        }
    }

    .amount_expansion .flex{padding: 8px 0px 0px 0px !important;}
    .expansion_header {text-transform: uppercase}
    .icolor {color: #0072BC}
    .icolor svg { vertical-align: middle; margin-right: 5px;}

    //.with_back_btn_con { display:none;}

    .with_back_btn_con svg {color:#0a2435; vertical-align: middle;display: none;}
    .nav_close_container{margin-top: 15px}

    @media only screen and (max-width: 959px){
        .amount_expansion__container {padding:0px;}
        .with_back_btn_con svg{display:initial}
        //.with_back_btn_con { display: initial}
    }


    .modal_body__content { margin-bottom: 20px;}
    .atooltip { margin-left: 10px;}

    #premium-container {
        .premium-box {
            border: 1px solid #e0dede;
            border-radius: 5px;
            .v-card__text {
                border-bottom: 1px solid #e0dede;
            }
            .v-card__text:last-child {
                border-bottom: none;
            }
        }
    }

    .span_text { font-size: 1rem;cursor: pointer;}

    .tooltip__content { font-size:1rem;text-align:justify}

    input#fdca_code{text-align:center;}

  



</style>
